const arraysAndJsonsHelpers = {}

arraysAndJsonsHelpers.areArraysEqual = function (arr1, arr2) {
  // Check if the arrays are the same length
  if (arr1.length !== arr2.length) return false

  // Sorting both arrays
  arr1 = arr1.sort()
  arr2 = arr2.sort()

  // Check if all items exist and are in the same order
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) return false
  }

  // Otherwise, return true
  return true
}
arraysAndJsonsHelpers.copyJson = function (json) {
  return JSON.parse(JSON.stringify(json))
}
arraysAndJsonsHelpers.isJson = function (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export default arraysAndJsonsHelpers
